module.exports = __webpack_public_path__ + "img/lg_ring_y_i_0_null@2x.18010b88.png";